import URLSearchParams from 'url-search-params';
import dayjs from 'dayjs';
import { iso8601DateFormat } from '../../format/dates';
import { SEARCH_ARRAY_KEYS } from '../../reducers/courses';

export const convertStringIntoArray = (str) => {
  const decoded = decodeURIComponent(str);
  const splitted = decoded.split(/[ ,+]/);

  const integered = splitted.map(n => parseInt(n, 10));
  // eslint-disable-next-line no-restricted-globals
  if (integered.some(i => isNaN(i))) {
    return splitted;
  }
  return integered;
};

// returns filter object
export function processLocationString(search = window.location.search, filter = {}) {
  const params = new URLSearchParams(search);

  const update = {};

  params.forEach((param, key) => {
    if (param) {
      if (['true', 'false'].includes(param)) {
        update[key] = param === 'true';
      } else if (param === 'null') {
        update[key] = null;
      } else if (Array.isArray(filter[key])) {
        update[key] = convertStringIntoArray(param);
      } else if (SEARCH_ARRAY_KEYS.indexOf(key) !== -1) {
        update[key] = convertStringIntoArray(param);
      } else if (dayjs(param).format(iso8601DateFormat) === param) {
        update[key] = dayjs(param).format(iso8601DateFormat);
      } else {
        update[key] = parseFloat(param) || param;
      }
    }
  });

  return { ...filter, ...update };
}

export function processQuery(query, filter = {}) {
  const result = {};

  Object.keys(query).forEach((key) => {
    const param = query[key];
    if (param) {
      if (['true', 'false'].includes(param)) {
        result[key] = param === 'true';
      } else if (param === 'null') {
        result[key] = null;
      } else if (Array.isArray(filter[key])) {
        result[key] = convertStringIntoArray(param);
      } else if (dayjs(param).format(iso8601DateFormat) === param) {
        result[key] = dayjs(param).format(iso8601DateFormat);
      } else {
        result[key] = parseFloat(param) || param;
      }
    }
  });

  return { ...filter, ...result };
}
